import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "BrowserRefresh.svg",
  "use": "BrowserRefresh.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"BrowserRefresh.svg\"><path d=\"M30,14.1227V9.0257a1.0245,1.0245,0,0,1,1.6182-.8191l9.9482,6.9888a.9968.9968,0,0,1,0,1.6381l-9.9482,6.9888A1.0245,1.0245,0,0,1,30,23.0032V18.1613A15.9936,15.9936,0,1,0,48.01,34.0208a2,2,0,1,1,4,0A20,20,0,1,1,30,14.1227Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol